// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shell */
.in-session-analytics {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  flex: 1 1;
  min-height: 0;
}

.oars-analytics-shell {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.oars-analytics-content {
  flex: 1 1;
  min-height: 0;
}

/* Specific Skills feedback cards in the three-column report panel.
   These headers carry a 28px icon button that the full-session cards
   (Interaction Log, Client Parameters) do not, and at align-items: center the
   button rather than the 18px title line box was setting the row height.
   Pulling it back into the padding leaves the title driving the height, so
   these headers match the full-session ones exactly; the button keeps its
   28px hit area and hover pill. The single-column drawer renders these cards
   under .oars-sidebar-feedback-scroll, so it keeps its own spacing. */
.oars-analytics-content .analytics-card-header .analytics-toggle-icon {
  margin-top: -0.375rem;
  margin-bottom: -0.375rem;
}

/* Header */
.analytics-header {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  z-index: 2;
  background: var(--surface-panel-color);
  padding-bottom: 0.1rem;
  flex-shrink: 0;
}

.dark .analytics-header {
  background: #1c2630;
}

.analytics-header-row {
  display: flex;
  /* Not baseline: the right-hand side is an icon button with no text, so it
     would baseline off its bottom edge and ride above the title. */
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.analytics-header-right {
  display: flex;
  align-items: center;
  gap: 0.55rem;
}

.analytics-header-copy {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.analytics-title {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 700;
  color: #0f172a;
  transition: color 0.3s ease;
}

.dark .analytics-title {
  color: #f8fafc;
}

.analytics-subtitle {
  margin: 0;
  font-size: 0.75rem;
  color: #6b7280;
  line-height: 1.5;
  transition: color 0.3s ease;
}

.dark .analytics-subtitle {
  color: #9ca3af;
}

.analytics-header-divider {
  border-top: 1px dashed #cbd5e1;
}

.dark .analytics-header-divider {
  border-top-color: #475569;
}

.analytics-toggle-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: color 0.15s ease, transform 0.15s ease;
  color: #64748b;
}

.analytics-toggle-chevron:hover {
  color: #475569;
}

.dark .analytics-toggle-chevron {
  color: #9ca3af;
}

.dark .analytics-toggle-chevron:hover {
  color: #d1d5db;
}

.analytics-toggle-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  transition: all 0.15s ease;
}

.analytics-toggle-icon svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.analytics-toggle-icon:hover {
  background: rgba(100, 116, 139, 0.12);
  color: #475569;
}

.analytics-toggle-icon:disabled {
  background: transparent;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.48;
}

.dark .analytics-toggle-icon:disabled {
  background: transparent;
  color: #6b7280;
}

.analytics-toggle-icon.on {
  color: #2563eb;
}

.dark .analytics-toggle-icon {
  color: #9ca3af;
}

.dark .analytics-toggle-icon:hover {
  background: rgba(156, 163, 175, 0.15);
  color: #d1d5db;
}

.dark .analytics-toggle-icon.on {
  color: #60a5fa;
}

/* Analytics Cards */
.analytics-sections {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.analytics-scroll-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-top: 0.65rem;
  padding-bottom: 1rem;
}

.analytics-scroll-body::-webkit-scrollbar {
  display: none;
}

.analytics-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.dark .analytics-card {
  background: #1f2937;
  border-color: #374151;
}

.analytics-card-header {
  padding: 0.75rem 1rem;
  background: #f3f4f6;
  border-bottom: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dark .analytics-card-header {
  background: #1f2937;
  border-bottom-color: #374151;
}

.analytics-card-title {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}

.dark .analytics-card-title {
  color: #9ca3af;
}

/* OARS Feedback Icon Variant */
.feedback-report-icon {
  color: #dc2626;
}

.feedback-report-icon svg {
  width: 16px;
  height: 16px;
  fill: currentColor;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.light .feedback-report-icon:hover {
  background: rgba(100, 116, 139, 0.12);
  color: #dc2626;
}

.light .feedback-report-icon.on {
  color: #dc2626;
}

.light .feedback-report-icon.on:hover {
  background: rgba(100, 116, 139, 0.12);
  color: #dc2626;
}

.dark .feedback-report-icon {
  color: #f87171;
}

.dark .feedback-report-icon:hover {
  background: rgba(156, 163, 175, 0.15);
  color: #f87171;
}

.dark .feedback-report-icon.on {
  color: #f87171;
}

.dark .feedback-report-icon.on:hover {
  background: rgba(156, 163, 175, 0.15);
  color: #f87171;
}

/* Analytics Copy */
.analytics-card-content {
  padding: 0.75rem 1rem 1rem;
  min-height: 60px;
}

/* Compact card bodies in the skills, strategies and full-session feedback panels. */
.analytics-sections .analytics-card .analytics-card-content {
  min-height: 0;
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
}

.analytics-sections .oars-attempt-entry {
  padding: 0.3rem 0;
}

.analytics-message {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin-bottom: 0.6rem;
  font-size: 0.85rem;
  line-height: 1.4;
  transition: all 0.3s ease;
}

.analytics-message:last-child {
  margin-bottom: 0;
}

.analytics-bullet {
  color: #3b82f6;
  font-weight: bold;
  flex-shrink: 0;
  transition: color 0.3s ease;
}

.dark .analytics-bullet {
  color: #60a5fa;
}

.analytics-text {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  font-size: 0.875rem;
  color: #374151;
  transition: color 0.3s ease;
}

.dark .analytics-text {
  color: #d1d5db;
}

.analytics-empty {
  margin: 0;
  padding: 0.5rem;
  font-size: 0.875rem;
  color: #9ca3af;
  text-align: center;
  font-style: italic;
  transition: color 0.3s ease;
}

.dark .analytics-empty {
  color: #6b7280;
}


/* Stage Metrics */
.stage-metrics-card .stage-metrics-grid {
  padding: 0.4rem 1rem 0.6rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.3rem 0.75rem;
}

.metric-item {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 0.3rem;
}

.metric-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.dark .metric-label {
  color: #9ca3af;
}

.metric-value {
  font-size: 0.82rem;
  font-weight: 600;
  color: #1f2937;
  transition: color 0.3s ease;
}

.dark .metric-value {
  color: #f3f4f6;
}

/* Revealed Items */
.revealed-items-section {
  margin-top: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
  transition: border-color 0.3s ease;
}

.dark .revealed-items-section {
  border-top-color: #374151;
}

.revealed-items-title {
  margin: 0 0 1rem 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #1f2937;
  transition: color 0.3s ease;
}

.dark .revealed-items-title {
  color: #f9fafb;
}

.revealed-category {
  margin-bottom: 1rem;
}

.revealed-category:last-child {
  margin-bottom: 0;
}

.revealed-category-title {
  margin: 0 0 0.5rem 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}

.dark .revealed-category-title {
  color: #9ca3af;
}

.revealed-list {
  margin: 0;
  padding-left: 1.25rem;
  list-style: none;
}

.revealed-item {
  position: relative;
  padding-left: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #374151;
  transition: color 0.3s ease;
}

.revealed-item:last-child {
  margin-bottom: 0;
}

.revealed-item::before {
  content: "✓";
  position: absolute;
  left: -1rem;
  color: #10b981;
  font-weight: bold;
  transition: color 0.3s ease;
}

.dark .revealed-item {
  color: #d1d5db;
}

.dark .revealed-item::before {
  color: #34d399;
}

.revealed-category.motivations .revealed-item::before {
  content: "+";
  color: #059669;
}

.dark .revealed-category.motivations .revealed-item::before {
  color: #34d399;
}

.revealed-category.barriers .revealed-item::before {
  content: "-";
  color: #dc2626;
}

.dark .revealed-category.barriers .revealed-item::before {
  color: #f87171;
}

/* Post-Session Review */
.panel-post-session-review {
  display: flex;
  flex: 1 1;
  min-height: 0;
}

.post-session-review {
  flex: 1 1;
  min-height: 0;
}

/* Back To Metrics */
.back-to-metrics-container {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}

.dark .back-to-metrics-container {
  border-top-color: #374151;
}

/* Responsive */
@media (max-width: 768px) {
  .in-session-analytics {
    padding: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/report/ReportFullSessionAnalytics.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;;;;;;;sEAOsE;AACtE;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb;mEACiE;EACjE,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,oFAAoF;AACpF;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;;AAGA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,SAAO;EACP,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Shell */\n.in-session-analytics {\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  flex: 1;\n  min-height: 0;\n}\n\n.oars-analytics-shell {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.oars-analytics-content {\n  flex: 1;\n  min-height: 0;\n}\n\n/* Specific Skills feedback cards in the three-column report panel.\n   These headers carry a 28px icon button that the full-session cards\n   (Interaction Log, Client Parameters) do not, and at align-items: center the\n   button rather than the 18px title line box was setting the row height.\n   Pulling it back into the padding leaves the title driving the height, so\n   these headers match the full-session ones exactly; the button keeps its\n   28px hit area and hover pill. The single-column drawer renders these cards\n   under .oars-sidebar-feedback-scroll, so it keeps its own spacing. */\n.oars-analytics-content .analytics-card-header .analytics-toggle-icon {\n  margin-top: -0.375rem;\n  margin-bottom: -0.375rem;\n}\n\n/* Header */\n.analytics-header {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  z-index: 2;\n  background: var(--surface-panel-color);\n  padding-bottom: 0.1rem;\n  flex-shrink: 0;\n}\n\n.dark .analytics-header {\n  background: #1c2630;\n}\n\n.analytics-header-row {\n  display: flex;\n  /* Not baseline: the right-hand side is an icon button with no text, so it\n     would baseline off its bottom edge and ride above the title. */\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.analytics-header-right {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n}\n\n.analytics-header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.analytics-title {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 700;\n  color: #0f172a;\n  transition: color 0.3s ease;\n}\n\n.dark .analytics-title {\n  color: #f8fafc;\n}\n\n.analytics-subtitle {\n  margin: 0;\n  font-size: 0.75rem;\n  color: #6b7280;\n  line-height: 1.5;\n  transition: color 0.3s ease;\n}\n\n.dark .analytics-subtitle {\n  color: #9ca3af;\n}\n\n.analytics-header-divider {\n  border-top: 1px dashed #cbd5e1;\n}\n\n.dark .analytics-header-divider {\n  border-top-color: #475569;\n}\n\n.analytics-toggle-chevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: color 0.15s ease, transform 0.15s ease;\n  color: #64748b;\n}\n\n.analytics-toggle-chevron:hover {\n  color: #475569;\n}\n\n.dark .analytics-toggle-chevron {\n  color: #9ca3af;\n}\n\n.dark .analytics-toggle-chevron:hover {\n  color: #d1d5db;\n}\n\n.analytics-toggle-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.analytics-toggle-icon svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.7;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.analytics-toggle-icon:hover {\n  background: rgba(100, 116, 139, 0.12);\n  color: #475569;\n}\n\n.analytics-toggle-icon:disabled {\n  background: transparent;\n  color: #9ca3af;\n  cursor: not-allowed;\n  opacity: 0.48;\n}\n\n.dark .analytics-toggle-icon:disabled {\n  background: transparent;\n  color: #6b7280;\n}\n\n.analytics-toggle-icon.on {\n  color: #2563eb;\n}\n\n.dark .analytics-toggle-icon {\n  color: #9ca3af;\n}\n\n.dark .analytics-toggle-icon:hover {\n  background: rgba(156, 163, 175, 0.15);\n  color: #d1d5db;\n}\n\n.dark .analytics-toggle-icon.on {\n  color: #60a5fa;\n}\n\n/* Analytics Cards */\n.analytics-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.analytics-scroll-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding-top: 0.65rem;\n  padding-bottom: 1rem;\n}\n\n.analytics-scroll-body::-webkit-scrollbar {\n  display: none;\n}\n\n.analytics-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.dark .analytics-card {\n  background: #1f2937;\n  border-color: #374151;\n}\n\n.analytics-card-header {\n  padding: 0.75rem 1rem;\n  background: #f3f4f6;\n  border-bottom: 1px solid #e5e7eb;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dark .analytics-card-header {\n  background: #1f2937;\n  border-bottom-color: #374151;\n}\n\n.analytics-card-title {\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #374151;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: color 0.3s ease;\n}\n\n.dark .analytics-card-title {\n  color: #9ca3af;\n}\n\n/* OARS Feedback Icon Variant */\n.feedback-report-icon {\n  color: #dc2626;\n}\n\n.feedback-report-icon svg {\n  width: 16px;\n  height: 16px;\n  fill: currentColor;\n  stroke: currentColor;\n  stroke-width: 1.7;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.light .feedback-report-icon:hover {\n  background: rgba(100, 116, 139, 0.12);\n  color: #dc2626;\n}\n\n.light .feedback-report-icon.on {\n  color: #dc2626;\n}\n\n.light .feedback-report-icon.on:hover {\n  background: rgba(100, 116, 139, 0.12);\n  color: #dc2626;\n}\n\n.dark .feedback-report-icon {\n  color: #f87171;\n}\n\n.dark .feedback-report-icon:hover {\n  background: rgba(156, 163, 175, 0.15);\n  color: #f87171;\n}\n\n.dark .feedback-report-icon.on {\n  color: #f87171;\n}\n\n.dark .feedback-report-icon.on:hover {\n  background: rgba(156, 163, 175, 0.15);\n  color: #f87171;\n}\n\n/* Analytics Copy */\n.analytics-card-content {\n  padding: 0.75rem 1rem 1rem;\n  min-height: 60px;\n}\n\n/* Compact card bodies in the skills, strategies and full-session feedback panels. */\n.analytics-sections .analytics-card .analytics-card-content {\n  min-height: 0;\n  padding-top: 0.55rem;\n  padding-bottom: 0.55rem;\n}\n\n.analytics-sections .oars-attempt-entry {\n  padding: 0.3rem 0;\n}\n\n.analytics-message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin-bottom: 0.6rem;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  transition: all 0.3s ease;\n}\n\n.analytics-message:last-child {\n  margin-bottom: 0;\n}\n\n.analytics-bullet {\n  color: #3b82f6;\n  font-weight: bold;\n  flex-shrink: 0;\n  transition: color 0.3s ease;\n}\n\n.dark .analytics-bullet {\n  color: #60a5fa;\n}\n\n.analytics-text {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.875rem;\n  color: #374151;\n  transition: color 0.3s ease;\n}\n\n.dark .analytics-text {\n  color: #d1d5db;\n}\n\n.analytics-empty {\n  margin: 0;\n  padding: 0.5rem;\n  font-size: 0.875rem;\n  color: #9ca3af;\n  text-align: center;\n  font-style: italic;\n  transition: color 0.3s ease;\n}\n\n.dark .analytics-empty {\n  color: #6b7280;\n}\n\n\n/* Stage Metrics */\n.stage-metrics-card .stage-metrics-grid {\n  padding: 0.4rem 1rem 0.6rem;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.3rem 0.75rem;\n}\n\n.metric-item {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  gap: 0.3rem;\n}\n\n.metric-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  transition: color 0.3s ease;\n  white-space: nowrap;\n}\n\n.dark .metric-label {\n  color: #9ca3af;\n}\n\n.metric-value {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #1f2937;\n  transition: color 0.3s ease;\n}\n\n.dark .metric-value {\n  color: #f3f4f6;\n}\n\n/* Revealed Items */\n.revealed-items-section {\n  margin-top: 0.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n  transition: border-color 0.3s ease;\n}\n\n.dark .revealed-items-section {\n  border-top-color: #374151;\n}\n\n.revealed-items-title {\n  margin: 0 0 1rem 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #1f2937;\n  transition: color 0.3s ease;\n}\n\n.dark .revealed-items-title {\n  color: #f9fafb;\n}\n\n.revealed-category {\n  margin-bottom: 1rem;\n}\n\n.revealed-category:last-child {\n  margin-bottom: 0;\n}\n\n.revealed-category-title {\n  margin: 0 0 0.5rem 0;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: color 0.3s ease;\n}\n\n.dark .revealed-category-title {\n  color: #9ca3af;\n}\n\n.revealed-list {\n  margin: 0;\n  padding-left: 1.25rem;\n  list-style: none;\n}\n\n.revealed-item {\n  position: relative;\n  padding-left: 0.5rem;\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  color: #374151;\n  transition: color 0.3s ease;\n}\n\n.revealed-item:last-child {\n  margin-bottom: 0;\n}\n\n.revealed-item::before {\n  content: \"✓\";\n  position: absolute;\n  left: -1rem;\n  color: #10b981;\n  font-weight: bold;\n  transition: color 0.3s ease;\n}\n\n.dark .revealed-item {\n  color: #d1d5db;\n}\n\n.dark .revealed-item::before {\n  color: #34d399;\n}\n\n.revealed-category.motivations .revealed-item::before {\n  content: \"+\";\n  color: #059669;\n}\n\n.dark .revealed-category.motivations .revealed-item::before {\n  color: #34d399;\n}\n\n.revealed-category.barriers .revealed-item::before {\n  content: \"-\";\n  color: #dc2626;\n}\n\n.dark .revealed-category.barriers .revealed-item::before {\n  color: #f87171;\n}\n\n/* Post-Session Review */\n.panel-post-session-review {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n}\n\n.post-session-review {\n  flex: 1;\n  min-height: 0;\n}\n\n/* Back To Metrics */\n.back-to-metrics-container {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.dark .back-to-metrics-container {\n  border-top-color: #374151;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .in-session-analytics {\n    padding: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
